import {
  RequestHookParams,
  useRequest,
  Category,
  request,
  ResponseWithMeta,
} from 'src/shared/api';
import { RequestByLimitOffset } from 'src/shared/api/request';
import { apiPublicRoutesMap, apiRoutesMap } from 'src/shared/config';
import { Notification } from './model';

export const useGetCategories = (
  params?: RequestHookParams<{ withEmpty?: boolean }>,
) => useRequest<Category[]>(apiPublicRoutesMap.categories.getRoute(), params);

export const useGetCategory = (
  params: RequestHookParams<{ id: string | number }>,
) =>
  useRequest<Category>(
    apiPublicRoutesMap.category.getRoute(params.variables.id),
    params,
  );

export const useGetnotifications = ({
  variables,
  ...params
}: RequestHookParams<
  {
    userId?: string | number;
    dateFrom?: string;
    dateTo?: string;
  } & RequestByLimitOffset
>) =>
  useRequest<
    ResponseWithMeta<{
      userId: number;
      userName: string;
      messages: Notification[];
    }>
  >(apiRoutesMap.notifications.getRoute(), {
    variables,
    ...params,
  });

export const createNotificationRequest = (data: {
  userIds: number[];
  title: string;
  body: string;
  category?: string;
}) => request.post(apiRoutesMap.notificationsSend.getRoute(), data);
